export const DATETIME_TIMEZONE = "Europe/Moscow";
export const DATETIME_ISO_8601_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";
